// components/NotificationProvider.tsx
import React, { createContext, useState } from 'react';
import { Snackbar, Alert, AlertColor } from '@mui/material';
import { DEFAULT_NOTIFICATION_DURATION } from '@/common/constants';

interface NotificationOptions {
    message: string;
    severity?: AlertColor;
    duration?: number;
}

interface NotificationContextProps {
    notify: (options: NotificationOptions) => void;
}

export const NotificationContext = createContext<NotificationContextProps | undefined>(undefined);

export const NotificationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [severity, setSeverity] = useState<AlertColor>('info');
    const [duration, setDuration] = useState(DEFAULT_NOTIFICATION_DURATION);

    const notify = ({ message, severity = 'info', duration = DEFAULT_NOTIFICATION_DURATION }: NotificationOptions) => {
        setMessage(message);
        setSeverity(severity);
        setDuration(duration);
        setOpen(true);
    };

    const handleClose = () => setOpen(false);

    return (
        <NotificationContext.Provider value={{ notify }}>
            {children}
            <Snackbar
                open={open}
                autoHideDuration={duration}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert onClose={handleClose} severity={severity} variant="filled" sx={{ width: '100%' }}>
                    {message}
                </Alert>
            </Snackbar>
        </NotificationContext.Provider>
    );
};
